module.exports = __webpack_public_path__ + "0bac6df74132549ef8182a454598b0f4.svg";